// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const ChromeIcon = createSvgIcon(
  <svg fill="currentColor" viewBox="0 0 24 24">
    <g clipPath="url(#chrome_svga)">
      <path
        fill="#188FD1"
        d="M12 16.8a4.8 4.8 0 1 0 0-9.6 4.8 4.8 0 0 0 0 9.6"
      />
      <path
        fill="#EA3939"
        d="M2.04 6.24a11.52 11.52 0 0 1 19.92 0l-7.08.84A5.76 5.76 0 0 0 6.24 12z"
      />
      <path
        fill="#4AAE48"
        d="M12 23.52A11.52 11.52 0 0 1 2.04 6.24L6.24 12a5.76 5.76 0 0 0 8.64 4.92z"
      />
      <path
        fill="#FED14B"
        d="M21.96 6.24A11.52 11.52 0 0 1 12 23.52l2.88-6.6a5.76 5.76 0 0 0 0-9.84z"
      />
    </g>
    <defs>
      <clipPath id="chrome_svga">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>,
  "Chrome",
);
export default ChromeIcon;
